export default __webpack_public_path__ + "static/1325-b625927d2f72595d41fc93d71621fc88.gif";